import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import clsx from 'clsx';
import ActionButton from 'components-v2/atoms/ActionButton';
import styles from './styles.module.css';

interface Props {
  classNames?: string;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  isOpen: boolean;
  isTitleCenter?: boolean;
  isDisableSubmit?: boolean;
  isLoadingSubmit?: boolean;
  title: string;
  subTitle?: string;
  children: React.ReactNode;
  submitText?: string;
  cancelText?: string;
  renderActions?: React.ReactNode;
  onSubmit?: (e?: React.MouseEvent<HTMLElement>) => void;
  onCancel?: (e?: React.MouseEvent<HTMLElement>) => void;
  onClose?: (e?: React.MouseEvent<HTMLElement>) => void;
}

export default function NotificationModal({
  classNames,
  maxWidth = 'xs',
  isOpen,
  isTitleCenter,
  isDisableSubmit = false,
  isLoadingSubmit = false,
  title,
  subTitle,
  children,
  submitText,
  cancelText,
  renderActions,
  onClose,
  onCancel,
  onSubmit,
}: Props) {
  const renderDefaultActions = () => {
    return (
      <>
        {cancelText && (
          <ActionButton variant="contained" color="secondary" onClick={onCancel}>
            {cancelText}
          </ActionButton>
        )}

        {submitText && (
          <ActionButton isLoading={isLoadingSubmit} disabled={isDisableSubmit} variant="contained" color="primary" onClick={onSubmit}>
            {submitText}
          </ActionButton>
        )}
      </>
    );
  };

  return (
    <Dialog transitionDuration={0} fullWidth maxWidth={maxWidth} className={clsx(classNames, styles.dialog)} onClose={onClose} open={isOpen}>
      <div className={clsx(styles.headerDialog, { [styles.isTitleCenter]: isTitleCenter })}>
        <DialogTitle className={clsx(styles.title)}>{title}</DialogTitle>
      </div>
      {subTitle && <DialogTitle className={styles.subTitle}>{subTitle}</DialogTitle>}
      <DialogContent className={styles.content}>{children}</DialogContent>
      <DialogActions className={styles.actions}>{renderActions || renderDefaultActions()}</DialogActions>
    </Dialog>
  );
}
